import { ACCOUNT_CREATION_ENTRYPOINTS_EXPERIMENT } from '@repo/absmartly/experiments';
import { ElementViewed } from '@repo/segment/Analytics/ElementViewed';
import { CONTROL_ENTITY_NAME, CONTROL_SECTION_NAME } from '../PromotionalButton/segment_constants';

type PromotionalControlTrackerProps = {
  slug: string;
};

export function PromotionalControlTracker({ slug }: PromotionalControlTrackerProps) {
  const roundupPath = `/banking/best/${slug}`;
  if (!ACCOUNT_CREATION_ENTRYPOINTS_EXPERIMENT.paths.includes(roundupPath)) {
    return null;
  }

  return (
    <ElementViewed entityName={CONTROL_ENTITY_NAME} sectionName={CONTROL_SECTION_NAME}>
      <div style={{ height: 0, overflow: 'hidden' }} />
    </ElementViewed>
  );
}
